import React from 'react';

import { Icon } from '../icons';

export const ArrowTopRightIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 16 16" fill={color} style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.97843 13.5723L2.85729 13.5723C2.38257 13.5723 1.99875 13.1885 2.00128 12.7163L1.99876 2.90122C1.99876 2.4265 2.38257 2.04269 2.85476 2.04521L12.6723 2.04521C13.1471 2.04521 13.5309 2.42903 13.5284 2.90122L13.5284 4.02237C13.5284 4.50214 13.1319 4.88848 12.6521 4.87838L6.71059 4.73445L13.9677 11.9916C14.3036 12.3274 14.3036 12.8678 13.9677 13.2036L13.1597 14.0117C12.8239 14.3475 12.2835 14.3475 11.9476 14.0117L4.69051 6.75452L4.83444 12.6961C4.84707 13.1784 4.46073 13.5748 3.97843 13.5723Z"
      />
    </svg>
  );
};
